// Copyright (c) 2017 Deere & Company

import KeyValuePair, {getDefaultState as getKeyValuePairDefaultState} from './key-value-pair';
import ReimbursedPercentIndicator, {getDefaultState as getReimbursedPercentIndicatorDefaultState} from './reimbursed-percent-indicator';
import t from 'tcomb';

const ReimbursementSummarySettings = t.struct({
    defaultRange: KeyValuePair,
    reimbursedPercentIndicator: ReimbursedPercentIndicator
}, {
    name: 'ReimbursementSummarySettings',
    strict: true
});

export const getDefaultState = () => new ReimbursementSummarySettings({
    defaultRange: getKeyValuePairDefaultState(),
    reimbursedPercentIndicator: getReimbursedPercentIndicatorDefaultState()
});

export default ReimbursementSummarySettings;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/reimbursement-summary-settings.js